import React, {Component} from "react";
import store from "../store";
import {withRouter} from "react-router";
import {snapImage} from "utils/file-utils";
import _ from "lodash";
import {showSpinner, hideSpinner} from "utils/spinner";
import {addUploads} from "../actions/upload-actions";

const style = {
    position: 'absolute',
    left: 0,
    opacity: 0,
    cursor: 'pointer',
    top: 0,
    width: 56,
    height: 56
};

const isChromeIOS = /crios/i.test(navigator.userAgent);

class ImageVideoPicker extends Component {

    constructor(props) {
        super(props);
        this.video = document.createElement('video');
    }

    readImageFile(file) {
        const fileReader = new FileReader();
        const promise =  new Promise((resolve, reject) => {
            fileReader.onload = () => {

                const url = fileReader.result;
                const thumbnail = url;
                const isVideo = false;
                const isGif = !!file.type.match('image/gif');
                const tempUUID = new Date().getTime();
                const creationDate = tempUUID;
                const fileName = file.name;
                const title = _.capitalize(fileName.replace(/(.*)\.[^.]+$/g, '$1'));
                const isAudio = false;
                const type = 'file';
                resolve({ thumbnail, tempUUID, isVideo, isGif, file, url, creationDate, fileName, isAudio, type, title });
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
            fileReader.readAsDataURL(file);
        });

        return promise.then(result => {
            store.dispatch(addUploads([result]));
        })
    }

    readVideoFile(file) {
        const tempUUID = new Date().getTime();
        const creationDate = tempUUID;
        const video = this.video;
        video.src = '';
        const promise =  new Promise((resolve, reject) => {
            const url = URL.createObjectURL(file);
            const timeupdate = function() {
                const thumbnail = snapImage(video);
                if (thumbnail) {
                    const o = {
                        fileName: file.name,
                        title: _.capitalize(file.name.replace(/(.*)\.[^.]+$/g, '$1')),
                        type: 'file',
                        isAudio: false,
                        isVideo: true,
                        tempUUID,
                        creationDate,
                        url,
                        thumbnail,
                        file
                    };
                    video.removeEventListener('timeupdate', timeupdate);
                    video.pause();
                    resolve(o);
                }
            };

            video.addEventListener('loadeddata', function() {
                const thumbnail = snapImage(video, file, url);
                if (thumbnail) {
                    const o = {
                        fileName: file.name,
                        title: _.capitalize(file.name.replace(/(.*)\.[^.]+$/g, '$1')),
                        type: 'file',
                        isAudio: false,
                        isVideo: true,
                        tempUUID,
                        creationDate,
                        url,
                        thumbnail,
                        file
                    };
                    video.removeEventListener('timeupdate', timeupdate);
                    resolve(o);
                }
            });

            video.addEventListener('timeupdate', timeupdate);

            video.addEventListener('error', (error) => {
                console.error("Error snapping thumbanil for video", error);
                reject(error);
            });
            video.preload = 'metadata';
            video.src = url;
            // Load video in Safari / IE11
            video.muted = true;
            video.playsInline = true;
            video.play();

        });

        return promise.then(result => {
            store.dispatch(addUploads([result]));
        })
    }

    readFile(file) {
        // also works for gif
        if (file.type.match('image')) {
            return this.readImageFile(file);
        }
        if (file.type.match('video')) {
            const isBigVideo = file.size > 50e6;
            if (isBigVideo) {
                const tempUUID = new Date().getTime();
                const creationDate = tempUUID;
                const url = URL.createObjectURL(file);
                return Promise.resolve({
                    fileName: file.name,
                    title: _.capitalize(file.name.replace(/(.*)\.[^.]+$/g, '$1')),
                    type: 'file',
                    isAudio: false,
                    isVideo: true,
                    tempUUID,
                    creationDate,
                    url,
                    file,
                    thumbnail: null
                }).then(result => {
                    store.dispatch(addUploads([result]));
                })
            } else {
                return this.readVideoFile(file);
            }
        }
    }

    readFiles(e) {
        showSpinner('xhr-on');
        const files = e.target.files;

        let p = Promise.resolve();

        _.each(files, file => {
            p = p.then(() => {
                return this.readFile(file);
            });
        });

        p.then(() => {
            hideSpinner('xhr-on');
        });

        this.props.router.push('/uploads');
    }

    render() {
        if (isChromeIOS) {
            return <input style={style} type="file"  accept="video/*,image/*" onChange={this.readFiles.bind(this)}/>
        }
        return <div>
            <input style={style} type="file" multiple accept="video/*,image/*" onChange={this.readFiles.bind(this)}/>
        </div>;
    }
}

export default withRouter(ImageVideoPicker)